import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-app-header',
  templateUrl: './about-app-header.component.html',
  styleUrls: ['./about-app-header.component.scss']
})
export class AboutAppHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
